/**
 * 将毫秒时间戳转换为`yyyy-MM-dd HH:mm:ss`格式日期字符串
 *  in:     1703485845000
 *  out:    2023-12-25 14:30
 * @param millisecondTimestampNumber    自1970-01-01 08:00:00至当前时间戳的毫秒数
 * @returns {string}                    `yyyy-MM-dd HH:mm`
 */
export const timestampNumber2datetimeString = (millisecondTimestampNumber) => {
    if (!millisecondTimestampNumber) return '—';
    // return dateString.substring(0, 16).replace('T', ' ');
    return formatTimestampDateTimeShort(millisecondTimestampNumber);
}
/**
 * 将毫秒时间戳转换为`yyyy-MM-dd` 格式日期字符串
 * @param millisecondTimestampNumber
 * @returns {string}
 */
export const timestampNumber2dateString = (millisecondTimestampNumber) => {
    if (!millisecondTimestampNumber) return '—';
    // return dateString.substring(0, 16).replace('T', ' ');
    return formatTimestampDate(millisecondTimestampNumber);
}
/**
 * 将毫秒时间戳转换为`yyyy-MM-dd HH:mm`格式日期字符串
 * @param millisecondTimestampNumber
 * @returns {string}
 */
export const timestampNumber2dateTimeFullString = (millisecondTimestampNumber) => {
    if (!millisecondTimestampNumber) return '—';
    // return dateString.substring(0, 16).replace('T', ' ');
    return formatTimestamp(millisecondTimestampNumber);
}
// yyyy-MM-dd HH:mm
function formatTimestamp(timestamp) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    // return `${year}-${month}-${day} ${hours}:${minutes}`;
}
function formatTimestampDateTimeShort(timestamp) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}`;
}

// yyyy-MM-dd HH:mm
function formatTimestampDate(timestamp) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    // return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return `${year}-${month}-${day}`;
}

/**
 * 将`yyyy-MM-dd HH:mm:ss`格式的时间字符串转换为时间戳
 *  in:     2023-12-25 14:30:45
 *  out:    1703485845000
 * @param dateTimeStr
 * @returns {number}
 */
export function dateTimeString2timestampNumber(dateTimeStr) {
    if (!dateTimeStr) return 0;
    if (typeof dateTimeStr === 'number') return 0;
    // 将yyyy-MM-dd HH:mm:ss格式转换为ISO格式
    // const isoStr = dateTimeStr.replace(' ', 'T') + '.000Z';
    // return new Date(isoStr).getTime();
    return Date.parse(dateTimeStr);
}

/**
 * 将时间戳或时间字符串设置为当天的凌晨 (00:00:00.000)
 * @param {number|string} timestampOrString 毫秒时间戳或时间字符串
 * @returns {number|null} 设置后的时间戳
 */
export function setStartOfDayTimestamp(timestampOrString) {
    if (!timestampOrString) return null;
    
    let timestamp;
    if (typeof timestampOrString === 'string') {
        timestamp = dateTimeString2timestampNumber(timestampOrString);
    } else {
        timestamp = timestampOrString;
    }
    
    if (!timestamp) return null;
    
    const date = new Date(timestamp);
    date.setHours(0, 0, 0, 0);
    return date.getTime();
}

/**
 * 将时间戳或时间字符串设置为当天的最后一毫秒 (23:59:59.999)
 * @param {number|string} timestampOrString 毫秒时间戳或时间字符串
 * @returns {number|null} 设置后的时间戳
 */
export function setEndOfDayTimestamp(timestampOrString) {
    if (!timestampOrString) return null;
    
    let timestamp;
    if (typeof timestampOrString === 'string') {
        timestamp = dateTimeString2timestampNumber(timestampOrString);
    } else {
        timestamp = timestampOrString;
    }
    
    if (!timestamp) return null;
    
    const date = new Date(timestamp);
    date.setHours(23, 59, 59, 999);
    return date.getTime();
}